import { get } from 'lodash';
import { searchEntities } from '../../store/selectors/search';

export const selectCommonAreaAssets = state => searchEntities(state, 'commonAreaAssets', ['serialNumber', 'item.name', 'item.model', 'item.makeName']);